import { useContext } from 'react';
import { DealContext } from '@dealstack/frontend/app/pages/Project/DealDashboard/DealContext';
import { CapInvalidTransactionsWarning } from '@dealstack/frontend/shared/components/CapInvalidTransactionsWarning/CapInvalidTransactionsWarning.tsx';

export function ValuationsCapTableWarningsMenu() {
	const { navigateToEntityWithInvalidTransactions } = useContext(DealContext);

	return (
		<CapInvalidTransactionsWarning
			showInvalidTransactions={navigateToEntityWithInvalidTransactions}
		/>
	);
}
